export function getTrackerLinkType(anchor) {
  if (anchor.matches("a[download]")) {
    return "download";
  } else if (anchor.matches("a[target='_blank']")) {
    return "link";
  } else {
    return undefined;
  }
}
